module.exports = __webpack_public_path__ + "media/images/dooh_1400x400-923fd717.svg";